import { createAsyncThunk } from "@reduxjs/toolkit";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const getAllCandidates = createAsyncThunk(
  "interview/getCandidates",
  async (_, thunkAPI) => {
    const response = await fetch(
      `${API_URL}/interview/all/candidates`,
      {
        method: "GET",
        credentials: "include",
      }
    );
    const result = await response.json();

    if (!response.ok) {
      return thunkAPI.rejectWithValue(result);
    }
    return result;
  }
);

export const createRomm = createAsyncThunk(
  "interview/createroom",
  async (data, thunkAPI) => {
    const { candidateId, scheduleAt } = data;


    const response = await fetch(`${API_URL}/interview/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        candidateId: candidateId,
        scheduledAt: scheduleAt,
      }),
    });
    const result = await response.json();

    if (!response.ok) {
      return thunkAPI.rejectWithValue(result);
    }
    return result;
  }
);

export const myInterviews = createAsyncThunk(
  "interview/myinterviews",
  async (_, thunkAPI) => {
    const response = await fetch(`${API_URL}/interview/me`, {
      method: "GET",
      credentials: "include",
    });
    const result = await response.json();

    if (!response.ok) {
      return thunkAPI.rejectWithValue(result);
    }
    return result;
  }
);


export const updateInterviewStatus = createAsyncThunk(
  'interview/updateStatus',
  async ({ status, id }, thunkAPI) => {
    const response = await fetch(`${API_URL}/interview/${id}/status`, {
      method: 'PATCH',
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
      body: JSON.stringify({
        status: status
      }),
    });
    const result = await response.json();

    if (!response.ok) {
      return thunkAPI.rejectWithValue(result);
    }
    return result;
  }
);


export const getSingleInterview = createAsyncThunk("interview/singleInterview",
  async (roomId, thunkAPI) =>{
    const response = await fetch(`${API_URL}/interview/${roomId}`,{
      method:"GET",
      credentials:"include",
    })
    const result = await response.json();
    if(!response.ok){
      return thunkAPI.rejectWithValue(result);
    }

    return result;
  }
)


export const saveNotesForInterviewer = createAsyncThunk("interview/notes",
  async ({roomId, text}, thunkAPI)=>{


    const response = await fetch(`${API_URL}/interview/notes/${roomId}`,{
      method:"PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      credentials:"include",
      body:JSON.stringify({
        text:text,
      })
    })
    const result = await response.json();
    if(!response.ok){
      return thunkAPI.rejectWithValue(result);
    }

    return result;
  }
)
